import { render, staticRenderFns } from "./privacy-policy-malaysia.vue?vue&type=template&id=2af03a7c&scoped=true&"
import script from "./privacy-policy-malaysia.vue?vue&type=script&lang=ts&"
export * from "./privacy-policy-malaysia.vue?vue&type=script&lang=ts&"
import style0 from "./privacy-policy-malaysia.vue?vue&type=style&index=0&id=2af03a7c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af03a7c",
  null
  
)

export default component.exports